module.exports = __webpack_public_path__ + "static/media/app-store-badge-en.0880d9e7.png";